module.exports = __webpack_public_path__ + "img/car_00031.a62b2b87.jpg";